import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  Color,
  Display,
  DisplayPosition,
  JustifyContent,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

import type { Recipe } from '@library/menu-service'
import { SoldOutOverlay } from '../SoldOutOverlay'

type RecipeTileReadyToHeatBannerProps = {
  recipe: Recipe
  isOutOfStock: boolean
}

const Banner = withCitrusTheme(Box, (theme) => ({
  containerType: 'inline-size',
  backgroundColor: theme.color(Color.Warning_900),
  padding: '2px 24px',
  borderBottomLeftRadius: '4px',
  borderBottomRightRadius: '4px',
}))

const FiveADayContainer = withCitrusTheme(Box, () => ({
  display: 'flex',
  alignItems: 'center',
  '@container (max-width: 352px)': {
    display: 'none',
  },
}))

const Separator = () => (
  <Body2 aria-hidden="true" color={Color.White} size={2} style={{ whiteSpace: 'nowrap' }}>
    •
  </Body2>
)

export const RecipeTileReadyToHeatBanner = ({
  recipe,
  isOutOfStock,
}: RecipeTileReadyToHeatBannerProps) => {
  if (recipe.preparationType !== 'heat-only') {
    return null
  }

  return (
    <Banner data-testid="recipe-tile-heat-only-banner" position={DisplayPosition.Relative}>
      <SoldOutOverlay backgroundColor={Color.White} isOutOfStock={isOutOfStock} />
      <Box
        display={Display.Flex}
        alignItems={AlignItems.Center}
        justifyContent={JustifyContent.SpaceAround}
        style={{ gap: '8px' }}
      >
        <Body2 color={Color.White} size={2} style={{ whiteSpace: 'nowrap' }}>
          Cooked by us
        </Body2>
        <Separator />
        {recipe.fiveADay !== null && recipe.fiveADay > 0 && (
          <>
            <FiveADayContainer>
              <Body2 color={Color.White} size={2} style={{ whiteSpace: 'nowrap' }}>
                {`${recipe.fiveADay} of 5 a day`}
              </Body2>
            </FiveADayContainer>
            <FiveADayContainer>
              <Separator />
            </FiveADayContainer>
          </>
        )}

        <Body2 color={Color.White} size={2} style={{ whiteSpace: 'nowrap' }}>
          No nasties
        </Body2>
      </Box>
    </Banner>
  )
}
